<template>
  <div class="container" @click="presentInfo">
    <span
      :class="{
        container__label__medium_and_bold: size === 'mediumBold',
        container__label__medium: size === 'medium'
      }"
      >{{ title }}</span
    >
    <div v-if="info" class="container__tooltip">
      <TooltipStandardV2
        :style="'margin-top: 5px; margin-left: 4px;'"
        :text="info"
        :arrowPosition="!fullscreen ? 'top-center' : 'center-right'"
        :verticalOffset="!fullscreen ? 4 : 1"
        :horizontalOffset="!fullscreen ? 0 : 2"
      >
        <IconSmallInfo class="container__tooltip__icon" />
      </TooltipStandardV2>
    </div>
  </div>
</template>

<script lang="ts" setup>
import IconSmallInfo from '../assets/icons/IconSmallInfo.vue'
import TooltipStandardV2 from '../atoms/TooltipStandardV2.vue'
import { onMounted, onUnmounted, ref } from 'vue'

type Props = {
  title?: string
  info?: string
  size?: 'medium' | 'mediumBold'
  fullscreen?: boolean
}

defineProps<Props>()

const isVisible = ref(false)

function presentInfo(e: MouseEvent) {
  e.stopPropagation()
  isVisible.value = isVisible.value ? false : true
}

function dismissInfo() {
  isVisible.value = false
}
/** Lifecycle hooks */
onMounted(() => document.addEventListener('click', dismissInfo))
onUnmounted(() => document.removeEventListener('click', dismissInfo))
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';

.container {
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: variables.$color-text-primary;
  &__label {
    &__medium_and_bold {
      @include font-mixins.desktop-bold-paragraph;
      margin-right: variables.$margin-small;
      margin-left: variables.$margin-small;
    }
    &__medium {
      @include font-mixins.desktop-regular-paragraph;
      margin-right: variables.$margin-small;
      margin-left: variables.$margin-small;
    }
  }
  &__tooltip {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &__icon {
      color: variables.$color-greyscale-secondary;
      height: 18px;
      width: 18px;
      cursor: pointer;
    }
    :nth-child(2) {
      top: 160%;
    }
  }
}
</style>
